import { render } from "./QuranPassages.vue?vue&type=template&id=549d88db&ts=true"
import script from "./QuranPassages.vue?vue&type=script&lang=ts"
export * from "./QuranPassages.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__